import React, { useEffect, useState } from "react";
import ProgressJourney from "./ProgressJourney";
import { getLeadPaymentLinks } from 'services/paymentServices';

/**
 * Legacy ProgressStepper component - kept for backward compatibility
 * For new implementations, use ProgressJourney component instead
 */
const ProgressStepper = ({ 
  leadId = null,
  activeStage = 2, 
  isMobile, 
  completedSteps = {}, 
  onStepClick = () => {}, 
  isClickable = true ,
  setProgressData =()=>{},
  progressData,
  leadCountry = null,
}) => {
  const [selectedStep, setSelectedStep] = useState(null);
  const [hasPaidFeeLink, setHasPaidFeeLink] = useState(false);

  useEffect(() => {
    if (leadId) {
      getLeadPaymentLinks(leadId).then(res => {
        if (res.success && res.data) {
          const links = res.data || [];
          const hasPaid = links.some(link => 
            link.LinkStatus?.toUpperCase() === 'PAID' && 
            (link.IsEnrollmentFee === true || link.IsAdmissionFee === true || link.GatewayCode === 'MAN')
          );
          setHasPaidFeeLink(hasPaid);
        }
      });
    }
  }, [leadId, progressData]); // Refetch if progressData refreshes

    useEffect(() => {
      if (progressData && Object.keys(progressData).length > 0) {
        // Determine the next step to be completed (Current Highlighting)
        let nextStep = 1;

        // Sequence: 1 -> 4 -> 5 -> 8 -> 6 -> 7 -> 9 -> 10 -> 2
        if (progressData?.IsDocumentUploaded && progressData?.IsFinalApproved) { nextStep = 4; }
        if (progressData.IsPaymentLinkGenerated) { nextStep = 5; }
        if (progressData.IsApplicationPaymentDone) { nextStep = 8; }
        if (progressData.IsInterviewScheduled) { nextStep = 6; }
        if (progressData.IsApplicationInitiated) { nextStep = 7; }
        if (progressData.IsApplicationSubmitted) { nextStep = 9; }
        if (progressData.IsFeePaymentLinkGenerated || progressData.IsFeePaymentDone || hasPaidFeeLink) { nextStep = 10; }
        if (progressData.IsFeePaymentDone || hasPaidFeeLink) { nextStep = 2; }

        setSelectedStep(nextStep);
      }
    }, [progressData]);
  
  return (
    <ProgressJourney
      leadId={leadId}
      currentStep={selectedStep}
      completedSteps={completedSteps}
      onStepClick={onStepClick}
      isClickable={isClickable}
      isMobile={isMobile}
      progressData={progressData}
      setProgressData={setProgressData}
      leadCountry={leadCountry}
    />
  );
};

// ---- Test Simulator ----
const StepperSimulator = ({ isMobile,leadId,setProgressData,progressData,handleStepClick=()=>{}, leadCountry = null }) => {
  const [stage, setStage] = useState(1);
  const [completedSteps, setCompletedSteps] = useState({});



  return (
    <div className="dark:bg-dark-800 rounded-xl bg-white p-6 ">
      <ProgressStepper
        isMobile={isMobile}
        leadId={leadId}
        activeStage={stage}
        completedSteps={completedSteps}
        onStepClick={handleStepClick}
        isClickable={true}
        setProgressData={setProgressData}
        progressData={progressData}
        leadCountry={leadCountry}

      />
    </div>
  );
};

export default StepperSimulator;
export { ProgressStepper };
